module.exports = __webpack_public_path__ + "static/media/exchangeNew.bfaae7a8.svg";